Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentNewsCommentHeaderView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/social_content_news_comment_header']

  initialize: (options = {}) ->
    @model = options.model

  render: ->
    @$el.html @template
      name: @model.getValue 'author'
      avatar: @model.getValue 'image'
      socialNetworkName: ''
    this
